import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
/* eslint-disable */
var router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            meta: {
                title: "湛联金融信用服务平台"
            },
            component: () => {
                return import("@/pages/Menu.vue");
            },
            redirect:{
                name: "index"
            },children: [
                {
                    name: "financePro",
                    path: "/financePro",
                    /*meta: {
                        title: "金融超市"
                    },*/
                    component: () => {
                        return import("@/pages/IndexProductNew.vue");
                    }
                },
                {
                    name: "financePro2",
                    path: "/financePro2",
                    /*meta: {
                        title: "金融超市"
                    },*/
                    component: () => {
                        return import("@/pages/IndexProductNew2.vue");
                    }
                },
                {
                    name: "zdcpShop",
                    path: "/zdcpShop",
                    /*meta: {
                        title: "金融超市"
                    },*/
                    component: () => {
                        return import("@/pages/zdcp/ZdcpShop");
                    }
                },
                {
                    name: "organization",
                    path: "/organization",
                    /*meta: {
                        title: "金融机构"
                    },*/
                    component: () => {
                        return import("@/pages/IndexOrganization.vue");
                    }
                },
                {
                    name: "creditInquiry",
                    path: "/creditInquiry",
                    meta: {
                        title: "信用查询"
                    },
                    component: () => {
                        return import("@/pages/IndexCreditInquiry.vue");
                    }
                },
                {
                    name: "news",
                    path: "/news",
                    /*meta: {
                        title: "咨询动态"
                    },*/
                    component: () => {
                        return import("@/pages/IndexNews.vue");
                    }
                },
                {
                    name: "fxts",
                    path: "/fxts",
                    /*meta: {
                        title: "风险提示"
                    },*/
                    component: () => {
                        return import("@/pages/Fxts.vue");
                    }
                },
                {
                    name: "introduce",
                    path: "/introduce",
                    /*meta: {
                        title: "咨询动态"
                    },*/
                    component: () => {
                        return import("@/pages/IndexIntroduce.vue");
                    }
                },
                {
                    name: "questions",
                    path: "/questions",
                    /*meta: {
                        title: "咨询动态"
                    },*/
                    component: () => {
                        return import("@/pages/IndexQuestions.vue");
                    }
                },
                {
                    name: "newsDetail",
                    path: "/newsDetail",
                    meta: {
                        title: "新闻详情"
                    },
                    component: () => {
                        return import("@/pages/NewsDetail.vue");
                    }
                },
                {
                    name: "sm_registe2",
                    path: "/sm_registe2",
                    meta: {
                        title: "用户注册"
                    },
                    component: () => {
                        return import("@/pages/registe2.vue");
                    }
                },
                {
                    name: "sm_data",
                    path: "/sm_data",
                    meta: {
                        title: "信用产品"
                    },
                    component: () => {
                        return import("@/pages/IndexData.vue");
                    }
                },
                {
                    name: "sm_subPlatform",
                    path: "/sm_subPlatform",
                    meta: {
                        title: "子系统登录"
                    },
                    component: () => {
                        return import("@/pages/subPlatform.vue");
                    }
                },
                {
                    name: "financeProduct_detail",
                    path: "/financeProduct_detail",
                    meta: {
                        title: "产品详情"
                    },
                    component: () => {
                        return import("@/pages/product/financeProduct_detail");
                    }
                },
                {
                    name: "zdcpShop_detail",
                    path: "/zdcpShop_detail",
                    meta: {
                        title: "转贷产品详情"
                    },
                    component: () => {
                        return import("@/pages/zdcp/ZdcpShop_Detail");
                    }
                },
                {
                    name: "SearchList",
                    path: "/SearchList",
                    meta: {
                        title: "搜索列表"
                    },
                    component: () => {
                        return import("@/pages/SearchList.vue");
                    }
                },
                {
                    name: "detail",
                    path: "/detail",
                    meta: {
                        title: "企业详情"
                    },
                    component: () => {
                        return import("@/pages/detail.vue");
                    }
                }
            ]
        },

        {
            name: "index",
            path: "/index",
            /*meta: {
                title: "首页"
            },*/
            component: () => {
                return import("@/pages/IndexNew.vue");
            }
        },

        {
            name: "bigScreen",
            path: "/bigScreen",
            meta: {
                title: "大屏展示"
            },
            component: () => {
                return import("@/pages/bigScreen/bigScreen.vue");
            }
        },
        {
            path: "/",
            redirect: {
                name: "Login"
            },
            component: () => {
                return import("@/pages/Page");
            },
            children: [
                {
                    name: "XYPT",
                    path: "crm",
                    meta: {
                        title: "信用工作平台"
                    },
                    component: () => {
                        return import("@/pages/CrmEnter");
                    },
                    children: [
                        {
                            name: "sm_login_manage",
                            path: "sm_login_manage",
                            meta: {
                                title: "登录页管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/setting/LoginManage");
                            }
                        },
                        {
                            name: "welcom",
                            path: "welcom",
                            meta: {
                                title: "欢迎"
                            },
                            component: () => {
                                return import("@/pages/welcom");
                            }
                        },
                        {
                            name: "sm_index_manage",
                            path: "sm_index_manage",
                            meta: {
                                title: "首页管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/setting/IndexManage");
                            }
                        },
                        {
                            name: "sm_menu_manage",
                            path: "sm_menu_manage",
                            meta: {
                                title: "菜单栏管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/setting/MenuManage");
                            }
                        },
                        {
                            name: "powerOfAttorneyManage",
                            path: "powerOfAttorneyManage",
                            meta: {
                                title: "授权书管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/setting/PowerOfAttorneyManage");
                            }
                        },
                        {
                            name: "loginAgreementManage",
                            path: "loginAgreementManage",
                            meta: {
                                title: "登录协议管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/setting/LoginAgreementManage");
                            }
                        },
                        {
                            name: "sm_work_manage",
                            path: "sm_work_manage",
                            meta: {
                                title: "工作页管管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/setting/WorkManage");
                            }
                        },
                        {
                            name: "sm_copyright_manage",
                            path: "sm_copyright_manage",
                            meta: {
                                title: "版权信息管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/setting/CopyrightManage");
                            }
                        },
                        {
                            name: "om_region_manage",
                            path: "om_region_manage",
                            meta: {
                                title: "行政区管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/yhgl/RegionManage");
                            }
                        },
                        {
                            name: "om_role_manage",
                            path: "om_role_manage",
                            meta: {
                                title: "角色管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/yhgl/RoleManage");
                            }
                        },
                        {
                            name: "om_org_manage",
                            path: "om_org_manage",
                            meta: {
                                title: "单位管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/yhgl/OrgManage");
                            }
                        },
                        {
                            name: "om_user_manage",
                            path: "om_user_manage",
                            meta: {
                                title: "用户管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/yhgl/UserManage");
                            }
                        },
                        {
                            name: "om_auth_manage",
                            path: "om_auth_manage",
                            meta: {
                                title: "权限管理",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/yhgl/AuthManage");
                            }
                        },

                        {
                            name: "om_log_manage",
                            path: "om_log_manage",
                            meta: {
                                title: "用户日志",
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/yhgl/LogManage");
                            }
                        },
                        {
                            name: "authority",
                            path: "authority",
                            meta: {
                                title: "没有权限，请联系管理员",
                                login: false,
                                authorize: false
                            },
                            component: () => {
                                return import("@/pages/Authority.vue");
                            }
                        },
                        {
                            name: "new",
                            path: "new/page/*",
                            meta: {
                                login: true,
                                authorize: true
                            },
                            component: () => {
                                return import("@/pages/NewPage");
                            }
                        },
                        {
                            path: 'sm_financeunit_manage',
                            name: 'sm_financeunit_manage',
                            meta: {
                                title: "金融产品管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/unit.vue')
                        },
                        {
                            path: 'yxdwUploadEnterpriseAuth',
                            name: 'yxdwUploadEnterpriseAuth',
                            meta: {
                                title: "授权协议",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/yxdwUploadEnterpriseAuth.vue')
                        },
                        {
                            path: 'groupByYxdwUser',
                            name: 'groupByYxdwUser',
                            meta: {
                                title: "分支机构统计",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/finance/groupByYxdwUser.vue')
                        },
                        {
                            path: 'sm_finance_manage',
                            name: 'sm_finance_manage',
                            meta: {
                                title: "金融产品管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/operate/business.vue')
                        },
                        {
                            path: 'kyxyfw',
                            name: 'kyxyfw',
                            meta: {
                                title: "可用信用服务",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/Kyxyfw.vue')
                        },
                        {
                            path: 'sm_unitcapitalize_manage',
                            name: 'sm_unitcapitalize_manage',
                            meta: {
                                title: "企业融资管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/finance.vue')
                        },
                        {
                            path: 'on_lending_product_order',
                            name: 'on_lending_product_order',
                            meta: {
                                title: "转贷订单管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/zdcp/ZdcpOrderManage.vue')
                        },
                        {
                            path: 'guaranteeOrder',
                            name: 'guaranteeOrder',
                            meta: {
                                title: "担保订单",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/guaranteeOrder.vue')
                        },
                        {
                            path: 'sjtj',
                            name: 'sjtj',
                            meta: {
                                title: "数据统计",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/sjtj.vue')
                        },
                        {
                            path: 'onlineMessage',
                            name: 'onlineMessage',
                            meta: {
                                title: "建议意见",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/onlineMessage/OnlineMessage.vue')
                        },
                        {
                            path: "sm_agreement_manage",
                            name: "sm_agreement_manage",
                            meta: {
                                title: "协议日志",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/yhgl/AgreementManage.vue")
                        },
                        {
                            path: 'managerManagement',
                            name: 'managerManagement',
                            meta: {
                                title: "经办人管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/managerManagement.vue')
                        },
                        {
                            path: 'declare',
                            name: 'declare',
                            meta: {
                                title: "自主申报",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/declare.vue')
                        },
                        {
                            path: 'affiliatedCompany',
                            name: 'affiliatedCompany',
                            meta: {
                                title: "关联企业",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/AffiliatedCompany.vue')
                        },
                        {
                            path: 'sm_company_manage',
                            name: 'sm_company_manage',
                            meta: {
                                title: "用信单位管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/operate/employer.vue')
                        },
                        {
                            path: "sm_unituser_manage",
                            name: "sm_unituser_manage",
                            meta: {
                                title: "用户管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/unituser.vue")
                        },
                        {
                            path: "sm_unituser_manage2",
                            name: "sm_unituser_manage2",
                            meta: {
                                title: "分支机构管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/unituser2.vue")
                        },
                        {
                            path: 'sm_query_manage',
                            name: 'sm_query_manage',
                            meta: {
                                title: "信用档案查询管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/archives.vue')
                        },
                        {
                            path: 'sm_query_manage2',
                            name: 'sm_query_manage2',
                            meta: {
                                title: "信用档案查询管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/archives2.vue')
                        },
                        {
                            path: 'sm_capitalize_monitor',
                            name: 'sm_capitalize_monitor',
                            meta: {
                                title: "企业融资办件监测",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/operate/monitor.vue')
                        },
                        {
                            path: 'yygrzx',
                            name: 'yygrzx',
                            meta: {
                                title: "运营个人中心",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/operate/yygrzx.vue')
                        },
                        /**
                         * @author lyf
                         * @date 2022/1/11
                         */
                        {
                            path: 'jrptsjtj',
                            name: 'jrptsjtj',
                            meta: {
                                title: "金融平台数据统计",
                                login: true,
                                authorize: true,
                            },
                            component: () => import('@/pages/finance/FinanceManager')
                        },
                        {
                            path: 'regionFinance',
                            name: 'regionFinance',
                            meta: {
                                title: "区域数据统计",
                                login: true,
                                authorize: true,
                            },
                            component: () => import('@/pages/finance/regionFinance.vue')
                        },
                        {
                            path: 'bbgl',
                            name: 'bbgl',
                            meta: {
                                title: "报表管理",
                                login: true,
                                authorize: true,
                            },
                            component: () => import('@/pages/finance/FinanceManager2')
                        },
                        {
                            path: 'zdcp',
                            name: 'zdcp',
                            meta: {
                                title: "转贷产品",
                                login: true,
                                authorize: true,
                            },
                            component: () => import('@/pages/zdcp/Zdcp')
                        },
                        {
                            path: 'zdcpsh',
                            name: 'zdcpsh',
                            meta: {
                                title: "转贷产品审核",
                                login: true,
                                authorize: true,
                            },
                            component: () => import('@/pages/zdcp/Zdcpsh')
                        },
                        {
                            path: 'sm_capitalize_manage',
                            name: 'sm_capitalize_manage',
                            meta: {
                                title: "融资企业管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/operate/enterprise.vue')
                        },
                        {
                            path: "sm_creditcatalogue_manage",
                            name: "sm_creditcatalogue_manage",
                            meta: {
                                title: "金融信用目录管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/creditCatalogue.vue")
                        },
                        {
                            path: "sm_creditdata_manage",
                            name: "sm_creditdata_manage",
                            meta: {
                                title: "金融信用数据管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/creditData.vue")
                        },
                        {
                            path: "sm_creditdissent_manage",
                            name: "sm_creditdissent_manage",
                            meta: {
                                title: "信用异议管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/creditDissent.vue")
                        },
                        {
                            path: 'authStatistics',
                            name: 'authStatistics',
                            meta: {
                                title: "授权协议统计",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/operate/authStatistics.vue')
                        },
                        {
                            path: 'sqxy2',
                            name: 'sqxy2',
                            meta: {
                                title: "授权协议",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/company/sqxy2.vue')
                        },
                        {
                            path: 'sm_mycapitalize_manage',
                            name: 'sm_mycapitalize_manage',
                            meta: {
                                title: "我的融资管理",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/self_management/my.vue')
                        },
                        {
                            path: 'zddd',
                            name: 'zddd',
                            meta: {
                                title: "转贷订单",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/zdcp/ZdcpOderCompany.vue')
                        },
                        {
                            path: 'grzx',
                            name: 'grzx',
                            meta: {
                                title: "个人中心",
                                login: true,
                                authorize: true
                            },
                            component: () => import('@/pages/self_management/grzx.vue')
                        },

                        {
                            path: 'xyda_sp_manage',
                            name: 'xyda_sp_manage',
                            meta: {
                                title: "信用档案管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/xydagl/XydaManage.vue")
                        },
                        /*{
                            path: "sm_unituser_manage",
                            name: "sm_unituser_manage",
                            meta: {
                                title: "用信单位用户管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/unituser.vue")
                        },*/
                        {
                            path: "sm_creditcatalogue_manage",
                            name: "sm_creditcatalogue_manage",
                            meta: {
                                title: "金融信用目录管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/creditCatalogue.vue")
                        },
                        {
                            path: "sm_creditdata_manage",
                            name: "sm_creditdata_manage",
                            meta: {
                                title: "金融信用数据管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/creditData.vue")
                        },
                        {
                            path: "sm_creditdissent_manage",
                            name: "sm_creditdissent_manage",
                            meta: {
                                title: "信用异议管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/creditDissent.vue")
                        },
                        {
                            path: "sm_independentdeclare_manage",
                            name: "sm_independentdeclare_manage",
                            meta: {
                                title: "自主申报管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/independentDeclare.vue")
                        },
                        {
                            path: 'sm_afterloan_manage',
                            name: 'sm_afterloan_manage',
                            meta: {
                                title: "企业融资贷后管理",
                            },
                            component: () => import('@/pages/company/afterLoan.vue')
                        },
                        {
                            path: 'dwgrzx',
                            name: 'dwgrzx',
                            meta: {
                                title: "单位个人中心",
                                login: true
                            },
                            component: () => import('@/pages/company/dwgrzx.vue')
                        },
                        {
                            path: 'sm_record_manage',
                            name: 'sm_record_manage',
                            meta: {
                                title: "企业失信记录管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/company/record.vue")
                        },
                        {
                            path: "sm_creditarchives_manage",
                            name: "sm_creditarchives_manage",
                            meta: {
                                title: "我的信用档案",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/self_management/companyManage.vue")
                        },
                        {
                            path: "companyManage",
                            name: "companyManage",
                            meta: {
                                title: "我的企业"
                            },
                            component: () =>
                                import("@/pages/self_management/companyManage.vue")
                        },

                        {
                            name: "sm_application_authority",
                            path: "/sm_application_authority",
                            meta: {
                                title: "权限申请",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/self_management/applicationAuthority.vue")
                        },

                        {
                            name: "sm_examine_application",
                            path: "/sm_examine_application",
                            meta: {
                                title: "权限申请",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/yhgl/ApplicationManage.vue")
                        },

                        {
                            path: "sm_param_manager",
                            name: "sm_param_manager",
                            meta: {
                                title: "参数管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/sysParam/sysParam.vue")
                        },

                        {
                            path: "sm_credittable_manage",
                            name: "sm_credittable_manage",
                            meta: {
                                title: "信用报告配置",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/creditTable/CreditTable.vue")
                        },
                        {
                            name: "zzsbsh",
                            path: "zzsbsh",
                            meta: {
                                title: "自主申报审核",
                                login: true,
                                authorize: true
                            },
                            component: () => import("@/pages/creditTable/zzsbsh.vue")
                        },
                        {
                            name: "zzsbpz",
                            path: "zzsbpz",
                            meta: {
                                title: "自主申报配置",
                                login: true,
                                authorize: true
                            },
                            component: () => import("@/pages/creditTable/zzsbpz.vue")
                        },







                        {
                            path: "sm_authorization_file",
                            name: "sm_authorization_file",
                            meta: {
                                title: "融资企业设置",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/sysParam/file.vue")
                        },
                        {
                            path: "sm_article_manage",
                            name: "sm_article_manage",
                            meta: {
                                title: "动态信息管理",
                                login: true,
                                authorize: true
                            },
                            component: () =>
                                import("@/pages/operate/article.vue")
                        },

                        {
                          path:"gzt",
                          name:"gzt",
                          meta:{
                               title:"中小企业工作台",
                               login:true,
                               authorize:true

                          },
                          component:()=>
                          import("@/pages/workplatform/gzt.vue")

                        },
                        {
                            path:"dwgzt",
                            name:"dwgzt",
                            meta:{
                                 title:"金融机构工作台",
                                 login:true,
                                 authorize:true

                            },
                            component:()=>
                            import("@/pages/workplatform/dwgzt.vue")

                        },
                        {
                            path:"yygzt",
                            name:"yygzt",
                            meta:{
                                title:"政府部门工作台",
                                login:true,
                                authorize:true

                            },
                            component:()=>
                                import("@/pages/workplatform/yygzt.vue")
                        },
                        {
                            path:"whiteList",
                            name:"whiteList",
                            meta:{
                                title:"白名单",
                                login:true,
                                authorize:true

                            },
                            component:()=>
                                import("@/pages/operate/whiteList.vue")
                        },

                               ]
                }
            ]
        },
        {
            name: "Login",
            path: "/login",
            meta: {
                title: "登录",
                login: false,
                authorize: false
            },
            component: () => {
                return import("@/pages/Login.vue");
            }
        },
        {
            path: "/loginCompany",
            redirect: {
                name: "LoginCompany"
            }
        },
        {
            name: "LoginCompany",
            path: "/login?type=1",
            meta: {
                title: "登录",
                login: false,
                authorize: false
            },
            component: () => {
                return import("@/pages/Login.vue");
            }
        },
        {
            path: "/loginFinance",
            redirect: {
                name: "LoginFinance"
            }
        },
        {
            name: "LoginFinance",
            path: "/login?type=2",
            meta: {
                title: "登录",
                login: false,
                authorize: false
            },
            component: () => {
                return import("@/pages/Login.vue");
            }
        },
        {
            name: "Err404",
            path: "*",
            meta: {
                title: "没有找到页面",
                login: false,
                authorize: false
            },
            component: () => {
                return import("@/Err404");
            }
        },
        {
            name: "prompt",
            path: "/prompt",
            meta: {
                title: "提示",
                login: false,
                authorize: false
            },
            component: () => {
                return import("@/prompt");
            }
        }
    ]
});

export default router;
